import React from 'react';
import { formatCurrency } from 'src/utils/stringUtils';

import styles from './pointPrice.module.css';

type PointPriceProps = {
  price: number;
};

const PointPrice = (props: PointPriceProps) => {
  const { price } = props;
  return <div className={styles.price}>{formatCurrency(price)}</div>;
};

export default PointPrice;
